<template>
    <div style="box-sizing: border-box;padding-top: 20px;">
        <div class="forms">
            <div class="formTitle flx alc">
                <div class="bshu"></div>
                <div class="ftname">
                    <span style="color: #007AFF;">1</span>/2 企业资料
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>企业logo:</span>
                </div>
                <div class="ips">
                    <el-upload class="upload-demo" action="https://two.hrxsl.com/api/Common/oss_upload"
                        :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2" :headers="uploadHeaders"
                        :show-file-list="false">
                        <div class="upavatar">
                            <img v-if="!forms.shop_avatar" :src="$img('/uploads/defaultAvatar.png')" alt="" />
                            <img v-else :src="$img(forms.shop_avatar)" alt="" />
                            <img class="pencil" :src="$Localimg('editAvatar.png')" alt="" />
                        </div>
                    </el-upload>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>上传营业执照:</span>
                </div>
                <div class="ips">
                    <el-upload class="upload-demo" action="https://two.hrxsl.com/api/Common/oss_upload"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders"
                        :show-file-list="false">
                        <div class="upimage">
                            <img v-if="!forms.zz_img" :src="$Localimg('up1.png')" alt="" />
                            <img v-else :src="$img(forms.zz_img)" alt="" />
                        </div>
                    </el-upload>
                </div>
                <div class="tis">
                    <div class="tiitem">
                        1、请上传工商营业执照,图片要求四角对齐,如有模糊、太暗、有遮挡,则不予认可
                    </div>
                    <div class="tiitem">
                        2、只支持中国大陆工商局或市场监督管理局颁发的工商营业执照,且必须在有效期内
                    </div>
                    <div class="tiitem">
                        3、需上传盖红章的营业执照原件，信息需清晰可见，内容真实有效，不得做任何修改
                    </div>
                    <div class="tiitem">
                        4、支持PNG、JPG、JPEG等格式,图片大小不超过8MB
                    </div>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>企业全称:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-input v-model="forms.zz_name" placeholder="请输入企业全称"></el-input>
                    </div>
                </div>
                <div class="tis">
                    <div class="tiitem">
                        工商营业执照上的企业全称,只支持中国大陆工商银行市场监督管理局登记的企业
                    </div>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>统一社会信用代码:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-input v-model="forms.zz_code" placeholder="请输入统一社会信用代码"></el-input>
                    </div>
                </div>
                <div class="tis">
                    <div class="tiitem">
                        18位统一社会信用代码或15位营业执照注册号
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>企业介绍:</span>
                </div>
                <div class="ips">
                    <div class="inps" style="height: auto !important;">
                        <!-- <textarea ></textarea> -->
                        <el-input type="textarea" class="fixed-textarea" placeholder="请输入企业介绍"
                            v-model="forms.shop_intro" maxlength="2000" show-word-limit>
                        </el-input>
                    </div>
                </div>
            </div>

            <div class="formTitle flx alc">
                <div class="bshu"></div>
                <div class="ftname">
                    <span style="color: #007AFF;">2</span>/2 运营者信息
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>姓名:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-input v-model="forms.sfz_name" placeholder="请输入您的姓名"></el-input>
                    </div>
                </div>
                <div class="tis">
                    <div class="tiitem">
                        运营者姓名与证件姓名保持一致
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>联系电话:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-input v-model="forms.zz_tel" placeholder="请输入您的联系电话"></el-input>
                    </div>
                </div>
                <div class="tis">
                    <div class="tiitem">
                         座机请填写纯数字，不需要输入横杠 -
                    </div>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>证件类型:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-select style="width: 100% !important;" v-model="forms.sfz_type" placeholder="请选择证件类型">
                            <el-option v-for="item in col1" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>证件号码:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-input v-model="forms.sfz_number" placeholder="请输入您的证件号码"></el-input>
                    </div>
                </div>
            </div>

            <div class="bot">
                <el-button type="primary" @click="subThis">提交资料</el-button>
                <div class="rules flx alc jsc">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="torules(6)">《商家实名认证服务协议》</b><b
                            class="cursor" style="color:#007AFF" @click="torules(7)">《服务使用协议》</b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        beShop,
        verback
    } from "@/api/index.js"
    export default {
        data() {
            return {
                remarks: "",
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                col1: [{
                        name: "身份证",
                        id: "1"
                    },
                    {
                        name: "护照",
                        id: "2"
                    }
                ],
                forms: {
                    zz_name: "",
                    zz_img: "",
                    zz_code: "",
                    zz_qiye: '',
                    sfz_type: "1",
                    zz_time: '',
                    admin_rbac: '',
                    sfz_img_zheng: '',
                    sfz_name: '',
                    sfz_number: '',
                    shop_avatar: "",
                    shop_intro: "",
                    zz_tel: ""
                },
                hasRead: false,
                checked1: false,
                checked2: false,
                // checked3: false,
            }
        },
        created() {},
        mounted() {
            verback().then((res) => {
                let that = this
                if (res.code == 1) {
                    if (res.data.is_status == 0) {
                        that.$router.push('/versuccess')
                    } else if (res.data.is_status == 2) {
                        that.remarks = res.data.remarks
                        that.forms.zz_name = res.data.zz_name
                        that.forms.zz_img = res.data.zz_img
                        that.forms.zz_code = res.data.zz_code
                        that.forms.zz_qiye = res.data.zz_qiye
                        that.forms.zz_tel = res.data.zz_tel
                        that.forms.zz_time = res.data.zz_time
                        that.forms.admin_rbac = res.data.admin_rbac
                        that.forms.sfz_type = res.data.sfz_type
                        that.forms.sfz_name = res.data.sfz_name
                        that.forms.sfz_number = res.data.sfz_number
                        that.forms.shop_avatar = res.data.shop_avatar
                        that.forms.shop_intro = res.data.shop_intro
                        that.open2()
                    }
                }
            })
        },
        methods: {
            torules(e) {
                window.open('https://two.hrxsl.com/rules?type=' + e + '&t=' + Date.now(), '_blank');
            },
            subThis() {
                let that = this
                if (that.hasRead == false) {
                    this.$message.error('请仔细阅读《商家实名认证服务协议》')
                    return
                }
                let ar = []
                if (that.checked1 == true) {
                    ar.push(1)
                }
                if (that.checked2 == true) {
                    ar.push(2)
                }
                that.forms.admin_rbac = ar.join()
                let data = that.forms
                beShop(data).then((res) => {
                    if (res.code == 1) {
                        that.$notify.closeAll()
                        setTimeout(() => {
                            that.$router.push('/versuccess')
                        }, 2000)
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.zz_img = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            handleAvatarSuccess2(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.shop_avatar = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            open2() {
                this.$notify({
                    title: '驳回原因',
                    message: this.remarks,
                    type: 'warning',
                    offset: 100,
                    duration: 0
                });
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 8 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            },
            handleAvatarSuccess1(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.sfz_img_zheng = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload1(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 7 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            }
        }
    }
</script>

<style scoped>
    /deep/ .fixed-textarea .el-textarea__inner {
        height: 100px !important;
        resize: none;
        overflow-y: auto;
    }

    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }

    .upavatar {
        width: 78px;
        height: 78px;
        position: relative;
    }

    .upavatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .pencil {
        width: 22px !important;
        height: 22px !important;
        position: absolute;
        right: 0;
        bottom: 0;
    }

    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .formitem {
        margin-bottom: 30px;
    }

    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }

    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        width: 258px;
        text-align: right;
    }

    .ips .inps {
        width: 300px;
        height: 46px;
    }

    /* 
    .ips .inps textarea {
        width: 100%;
        border: 1px solid #DCDFE6;
        display: inline-block;
        height: 40px;
        box-sizing: border-box;
        padding: 15px;
        resize: none !important;
        outline: none !important;
    } */

    .upimage {
        width: 300px;
        height: 204px;
    }

    .upimage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .formTitle {
        margin-bottom: 31px;
    }

    .ftname {
        font-weight: 500;
        font-size: 18px;
    }

    .bshu {
        width: 3px;
        height: 16px;
        background: #007AFF;
        margin-right: 12px;
    }

    .forms {
        width: 1460px;
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 64px 40px;
    }
</style>